import { FC, useEffect } from "react";
import { useAppConfig } from "rwo-react";
import { initTelemetry } from "./otel";

/**
 * Initialises OpenTelemetry once AppConfig has loaded, using the OTLP/HTTP
 * exporter URL from `Otlp:AlloyApiUrl` and the subscription key from
 * `Otlp:AlloyApiSubscriptionKey`. Rendered inside `AppConfigProvider` (which
 * only renders its children after config is ready), so the values are available
 * on first effect. No-ops when the URL is unset.
 */
export const TelemetryInitializer: FC = () => {
  const { config } = useAppConfig();

  useEffect(() => {
    initTelemetry(
      config["Otlp:AlloyApiUrl"],
      config["Otlp:AlloyApiSubscriptionKey"],
    );
  }, [config]);

  return null;
};
